/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const headerTrlDtoSchema = z.object({
  level: z.optional(z.int()),
  description: z.optional(z.string()),
  label: z.optional(z.string()),
});
